import { routes } from '../config/api_routes'

export const attributeService = {

    getAttributeList: (formData) => {    
        return window.axios.post(routes.getAttributeListApi,formData)
    },
    addAttribute: (formData) => {    
        return window.axios.post(routes.addAttributeApi,formData)
    },
    getAttributeById: (formData) => {    
        return window.axios.post(routes.getAttributeByIdApi,formData)
    },
    editAttribute: (formData) => {    
        return window.axios.post(routes.editAttributeApi,formData)
    },
    deleteAttribute: (formData) => {    
        return window.axios.post(routes.deleteAttributeApi,formData)
    },
    getallBoxCategory: (formData) => {    
        return window.axios.post(routes.getallBoxCategoryApi,formData)
    }
}